<rdo-breadcrumb></rdo-breadcrumb>
<rdo-overlay [enabled]="loading"></rdo-overlay>
<div class="container-fluid rental-assets-page" id="rental-asset" [attr.data-max-num-days-in-status]="maxNumDaysInStatus()">
  <div class="row">
    <div class="col-12" id="rdo-grid" >
      <rdo-saved-time [gridConfig]="gridConfig()" />
      <ng-container *featureFlag="'flagSavedViews'">
        <rdo-saved-views
          [gridName]="gridName"
          [pageName]="translateService.instant('main.tabs.equipment.rental_assets.title')" />
      </ng-container>
      @if (data) {
        <rdo-grid-table-ng
          #grid
          [name]="gridName"
          [gridConfig]="gridConfig()"
          [pagedData]="data"
          [sorting]="sorting"
          [(paging)]="paging"
          [scrollScale]="'largeScale'"
          (pageOnChange)="changePage($event)"
          (lazyLoadOnChange)="changeLazyLoad($event)"
          [totalCount]="totalCount"
          [frozenWidth]="frozenWidth"
          [showColumnSelector]="true"
          (downloadExcelClick)="exportExcel($event)">
        </rdo-grid-table-ng>
      }
    </div>
  </div>
</div>
